import { STORAGE_KEYS } from '~/constants/storageKeys';

const SESSION_DEDUP_KEY = STORAGE_KEYS.BEHAVIOR_PROPERTY_VIEWED_IDS;

function readViewedIds(): string[] {
	if (!import.meta.client) return [];
	try {
		const stored = sessionStorage.getItem(SESSION_DEDUP_KEY);
		return stored ? JSON.parse(stored) : [];
	} catch {
		return [];
	}
}

function writeViewedIds(ids: string[]): void {
	if (!import.meta.client) return;
	try {
		sessionStorage.setItem(SESSION_DEDUP_KEY, JSON.stringify(ids));
	} catch {
		// sessionStorage unavailable
	}
}

export function hasViewedPropertyThisSession(propertyId: string): boolean {
	return readViewedIds().includes(propertyId);
}

export function markPropertyViewedThisSession(propertyId: string): void {
	const ids = readViewedIds();
	if (ids.includes(propertyId)) return;
	ids.push(propertyId);
	writeViewedIds(ids);
}

/** Lets a dropped view be sent again later in the session. */
export function unmarkPropertyViewedThisSession(propertyId: string): void {
	const ids = readViewedIds();
	if (!ids.includes(propertyId)) return;
	writeViewedIds(ids.filter(id => id !== propertyId));
}
